export default "__VITE_ASSET__Cla5V7oJ__"